import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useState } from 'react';
import { Bubble, List, Popover } from 'tea-component';

import { useDeleteFavoritePage } from '../hooks';
import { getLocale, useIntl } from 'umi';
import SaveReport from './SaveReport';
import { DBO_POINT } from '@op/operationLog/buriedPoint';

const MenuPopover = (props: any) => {
  const {
    FavoritesType,
    menuItem,
    gameInfo,
    userInfo,
    wholeGameInfo,
    id,
    deleteCallback,
    addCallback,
    sortCallback,
    upDisable,
    downDisable,
    selectedFilter,
    filterDefaultValue,
    loading,
    editInfo,
  } = props;
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  const { handleRemove } = useDeleteFavoritePage({
    gameInfo,
    id,
  });

  const { formatMessage } = useIntl();

  const handleClickAddOrRename = () => {
    setVisible(!visible);
    if (FavoritesType) {
      handleRemove(() => {
        deleteCallback?.(id);
      });
    } else {
      setOpen(!open);
    }


    console.log(menuItem, "---------")
    DBO_POINT.btnOri('addFavorite', {
      extInfo: JSON.stringify({ gameid: gameInfo.edition_unified_id }),
      extInfo2: menuItem?.actualPath,
    });
  };

  const handleClickSort = (type: 'down' | 'up') => {
    sortCallback(id, type, gameInfo.edition_unified_id);
  };

  const lang = getLocale();

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {!FavoritesType ? (
        <Bubble
          closeOnScroll
          dark
          content={formatMessage({ id: 'Add to My Reports' })}
        >
          <span className="left-nav-absolute" onClick={handleClickAddOrRename}>
            <SvgIcon type="star-m" />
          </span>
        </Bubble>
      ) : (
        <Popover
          visible={visible}
          onVisibleChange={(visible) => setVisible(visible)}
          placement="right-start"
          placementOffset={[-10, 32]}
          trigger="click"
          closeOnScroll
          overlay={
            <div className="left-nav-exit">
              <List type="option">
                {FavoritesType ? (
                  <List.Item
                    onClick={() => {
                      setOpen(true);
                      setVisible(false);
                    }}
                  >
                    <div className="dbd-sub-nav">
                      <SvgIcon type="pencil-m" className="dbd-sub-nav-icon" />
                      <div className="dbd-sub-nav-text">
                        {formatMessage({ id: 'Edit' })}
                      </div>
                    </div>
                  </List.Item>
                ) : null}
                <List.Item onClick={handleClickAddOrRename}>
                  <div className="dbd-sub-nav">
                    <SvgIcon
                      type={FavoritesType ? 'star-delete' : 'star-add-icon'}
                      className="dbd-sub-nav-icon"
                    />
                    <div className="dbd-sub-nav-text">
                      {formatMessage({
                        id: FavoritesType
                          ? 'Remove from Favorites'
                          : 'Add to My Report',
                      })}
                    </div>
                  </div>
                </List.Item>
                {FavoritesType ? (
                  <>
                    <List.Item className="tea-list__separate dbd-sub-line" />
                    <Popover
                      // visible={true}
                      placement="right-start"
                      placementOffset={[0, 8]}
                      overlayClassName="dbi-sub-popover"
                      overlay={
                        <div className="tea-dropdown-box">
                          <List type="option">
                            <List.Item
                              disabled={upDisable}
                              onClick={() => handleClickSort('up')}
                            >
                              <div className="dbd-sub-nav">
                                <SvgIcon
                                  type="rising-arrow-icon"
                                  className="dbd-sub-nav-icon"
                                />
                                <div className="dbd-sub-nav-text">
                                  {formatMessage({
                                    id: 'Shift up',
                                  })}
                                </div>
                              </div>
                            </List.Item>
                            <List.Item
                              disabled={downDisable}
                              onClick={() => handleClickSort('down')}
                            >
                              <div className="dbd-sub-nav">
                                <SvgIcon
                                  type="down-arrow-icon"
                                  className="dbd-sub-nav-icon"
                                />
                                <div className="dbd-sub-nav-text">
                                  {formatMessage({
                                    id: 'Shift down',
                                  })}
                                </div>
                              </div>
                            </List.Item>
                          </List>
                        </div>
                      }
                    >
                      <List.SubMenu
                        label={
                          <div className="dbd-sub-nav">
                            <SvgIcon
                              type="order-icon"
                              className="dbd-sub-nav-icon"
                            />
                            <div className="dbd-sub-nav-text">
                              {formatMessage({ id: 'Order' })}
                            </div>
                          </div>
                        }
                      ></List.SubMenu>
                    </Popover>
                  </>
                ) : null}
              </List>
            </div>
          }
        >
          <span
            className="left-nav-absolute"
            onClick={(e) => {
              setVisible(!visible);
            }}
          >
            <SvgIcon type="more" />
          </span>
        </Popover>
      )}
      {open && !loading && (
        <SaveReport
          pagePath={menuItem?.actualPath || menuItem?.assembly_url}
          visible={open}
          gameInfo={gameInfo}
          userInfo={userInfo}
          wholeGameInfo={wholeGameInfo}
          close={() => setOpen(!open)}
          addCallback={addCallback}
          defaultSelectedFilter={selectedFilter}
          defaultFilterValue={filterDefaultValue}
          editInfo={editInfo}
          originalName={
            menuItem[lang === 'en-US' ? 'name_en' : 'name_cn'] ||
            menuItem.name_en
          }
        />
      )}
    </div>
  );
};

export default MenuPopover;
